export interface FooterProps {}

export const Footer = (props: FooterProps) => {
  return <></>;
};
